var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.open}},[_c('avatar',{attrs:{"size":24}},[_c('img',{attrs:{"src":_vm.profilePicture}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }